import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { formatAmount } from "./format";
import { computeAverageStats, rangeMetrics } from "./rangeMetrics";
import { TEXT_SECONDARY } from "./palette";

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75em;
`;

const Tile = styled.div`
  flex: 1 1 240px;
  padding: 1.1em 1.4em;
  background: #fff;
  border: 1px solid rgba(11, 11, 11, 0.06);
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
`;

const CurrencyName = styled.div`
  font-size: 12px;
  color: ${TEXT_SECONDARY};
  margin-bottom: 0.45em;
`;

const StatRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.75em;
  font-size: 13px;

  &:not(:last-child) {
    margin-bottom: 0.4em;
  }
`;

const StatLabel = styled.span`
  color: ${TEXT_SECONDARY};
`;

const StatValue = styled.span`
  font-weight: 600;
`;

export default function AverageStatsCards({ noteSpending, months, startDate, endDate }) {
  if (!noteSpending || noteSpending.length === 0) {
    return null;
  }

  const metrics = rangeMetrics({ months, startDate, endDate });
  const stats = computeAverageStats(noteSpending, metrics);

  if (stats.length === 0) {
    return null;
  }

  return (
    <Row>
      {stats.map(({ currency, monthlyAvgExpense, dailyAvgExpense, transactionCount }) => (
        <Tile key={currency.id}>
          <CurrencyName>{currency.name}</CurrencyName>
          <StatRow>
            <StatLabel>平均每月支出</StatLabel>
            <StatValue>{formatAmount(monthlyAvgExpense)}</StatValue>
          </StatRow>
          <StatRow>
            <StatLabel>平均每日支出</StatLabel>
            <StatValue>{formatAmount(dailyAvgExpense)}</StatValue>
          </StatRow>
          <StatRow>
            <StatLabel>支出筆數</StatLabel>
            <StatValue>{transactionCount}</StatValue>
          </StatRow>
        </Tile>
      ))}
    </Row>
  );
}

AverageStatsCards.propTypes = {
  noteSpending: PropTypes.arrayOf(PropTypes.object),
  months: PropTypes.number,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

AverageStatsCards.defaultProps = {
  noteSpending: null,
  months: undefined,
  startDate: undefined,
  endDate: undefined,
};
